import { NeverEndingSummerBackground } from 'components/Common/SiteTakeover/NeverEndingSummer/NeverEndingSummerBackground'
import { NeverEndingSummerLogo } from 'components/Common/SiteTakeover/NeverEndingSummer/NeverEndingSummerLogo'
import TextLink from 'LuxKit/TextLink'
import moment from 'moment'
import React from 'react'

export const NeverEndingSummerTakeover: App.SiteTakeover = {
  id: 'neverendingsummer',
  startDate: moment('2025-07-23T00:00:00+0000'), // UK Time
  endDate: moment('2025-08-06T23:59:00+0000'), // UK Time
  brands: new Set(['luxuryescapes']),
  regions: new Set(['GB', 'FR', 'IT', 'ES', 'NL', 'DE', 'IE']),
  verticals: new Set(['home']),
  palette: 'default',
  primaryColour: '',
  backgroundElement: NeverEndingSummerBackground,
  heroCarousel: {
    title: 'Never-ending Summer',
    subtitle: <>Last-minute getaways. Escape while offers last! <TextLink wrap="no-wrap" to="/campaign/neverendingsummer">View all offers</TextLink></>,
    logo: <NeverEndingSummerLogo />,
    filters: [],
    palette: 'default',
    verticals: ['home'],
  },
}
